import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProfileImageComponent } from './profile-image.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [ProfileImageComponent],
  exports: [ProfileImageComponent],
  imports: [CommonModule, MatIconModule],
})
export class ProfileImageModule {}
